import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ukLocale from 'date-fns/locale/uk';
import Auth from './auth';
import Messages from './components/Messages';

import AdminRoute from './components/AdminRoute/index';
import AlreadyAuthRoute from './components/AlreadyAuthRoute';
import CabinetRoute from './components/CabinetRoute';

import LoginView from './auth/views/LoginView';
import RegistrationView from './auth/views/RegistrationView';

// cabinet views
import CabinetMain from './cabinet/Main';
import CabinetManagers from './cabinet/Managers';
import CabinetPermissions from './cabinet/Permissions';
import CabinetSuperManagers from './cabinet/SuperManagers';
import CabinetTrainers from './cabinet/Trainers';
import CabinetGroups from './cabinet/Groups';
import CabinetGyms from './cabinet/Gyms';
import CabinetAthletes from './cabinet/Athletes';
import CabinetClubs from './cabinet/Clubs';
import CabinetContributions from './cabinet/Contributions';
import CabinetCertifications from './cabinet/Certification';
import CabinetStats from './cabinet/Stats';
import Dankai from './cabinet/Dankai';

// admin views
import AdminMain from './admin/Main';
import AdminTasks from './admin/Tasks';

import { getLoginUrl, getRegistrationUrl } from './auth/urls';

// locale
import { initLocale, LocaleProvider, setRoutePath } from './components/Locale';
import { MenuProvider } from './components/MenuList/provider';
import ApiProvider from './api/provider';
import router from './api/router';

initLocale();

const App = () => (
  <LocaleProvider>
    <Messages>
      <MenuProvider>
        <Auth>
          <ApiProvider>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ukLocale}>
              <Switch>
                <Redirect exact from='/' to='/cabinet' />
                <Route
                  exact
                  path={setRoutePath(getLoginUrl())}
                  component={LoginView}
                />
                <Route
                  exact
                  path={setRoutePath(getRegistrationUrl())}
                  component={RegistrationView}
                />

                <AlreadyAuthRoute
                  exact
                  path={setRoutePath(getLoginUrl())}
                  component={LoginView}
                />
                <AlreadyAuthRoute
                  exact
                  path={setRoutePath(getRegistrationUrl())}
                  component={RegistrationView}
                />

                <CabinetRoute
                  exact
                  path={setRoutePath('/cabinet')}
                  component={CabinetMain}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.managers.list())}
                  component={CabinetManagers}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.trainers.list())}
                  component={CabinetTrainers}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.groups.list())}
                  component={CabinetGroups}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.gyms.list())}
                  component={CabinetGyms}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.athletes.list())}
                  component={CabinetAthletes}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.contributions.list())}
                  component={CabinetContributions}
                />
                <CabinetRoute
                  path={setRoutePath(router.cabinet.certifications.list())}
                  component={CabinetCertifications}
                />
                <CabinetRoute
                  path={setRoutePath('/cabinet/statistics')}
                  component={CabinetStats}
                />
                <CabinetRoute
                  path={setRoutePath('/cabinet/dankai')}
                  component={Dankai}
                />
                <AdminRoute
                  exact
                  path={setRoutePath('/admin')}
                  component={AdminMain}
                />
                <AdminRoute
                  path={setRoutePath('/admin/tasks')}
                  component={AdminTasks}
                />

                <AdminRoute
                  path={setRoutePath(router.admin.superManagers.list())}
                  component={CabinetSuperManagers}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.permissions.list())}
                  component={CabinetPermissions}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.certifications.list())}
                  component={CabinetCertifications}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.managers.list())}
                  component={CabinetManagers}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.trainers.list())}
                  component={CabinetTrainers}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.clubs.list())}
                  component={CabinetClubs}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.athletes.list())}
                  component={CabinetAthletes}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.gyms.list())}
                  component={CabinetGyms}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.groups.list())}
                  component={CabinetGroups}
                />
                <AdminRoute
                  path={setRoutePath(router.admin.contributions.list())}
                  component={CabinetContributions}
                />
                <AdminRoute
                  path={setRoutePath('/admin/statistics')}
                  component={CabinetStats}
                />
                <AdminRoute
                  path={setRoutePath('/admin/dankai')}
                  component={Dankai}
                />
                <Route component={() => <div>404</div>} />
              </Switch>
            </MuiPickersUtilsProvider>
          </ApiProvider>
        </Auth>
      </MenuProvider>
    </Messages>
  </LocaleProvider>
);

export default App;
